import React, { useEffect, useState } from "react";
import styles from "./ImageNode.module.scss";
import NodeContainer from "../node-container/NodeContainer";
import { Handle, Position, useNodes } from "@xyflow/react";
import ImageModal from "./image-modal/ImageModal";
import SvgWithBranding from "component/hoc/branding/withBrandingColor.hoc";
const ImageNode = ({ id, selected }) => {
  const nodes = useNodes();
  const node = nodes.find((node) => node.id === id);

  const [isError, setIsError] = useState(node?.is_Error || false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const media = node?.media;
  const isEmptyMedia =
    node?.media == undefined ||
    (media?.uploadedFile == "" &&
      media?.url == "" &&
      (media?.fileName == "" || media?.fileName == undefined));
  const isImageURL = media?.isURL == false && media?.url !== "";

  useEffect(() => {
    if (node?.media) {
      if (isEmptyMedia) {
        setIsError(true);
      } else {
        setIsError(false);
      }
    } else {
      setIsError(node?.is_Error || true);
    }
  }, [node?.media]);
  return (
    <>
      <NodeContainer
        name={node?.title ?? "Image Block"}
        backgroundColor={node?.color}
        id={id}
        onClick={() => setIsModalOpen(true)}
        selected={selected}
        node={node}
        isError={isError}
      >
        <Handle
          type='target'
          position={Position.Left}
          className='custom-handle'
        />

        {isEmptyMedia ? (
          <div className={styles.document}>
            <SvgWithBranding
              type='node-image'
              color='#787878'
            />
            <div className={styles.text}>
              <p>Image</p>
              <span>Upload an image or GIF</span>
            </div>
          </div>
        ) : (
          <div
            className={`${styles.document} ${
            styles.image 
            }`}
          >
            <div className={styles.text}>
              <img
                src={
                  node?.media?.uploadedFile
                    ? URL.createObjectURL(node?.media?.uploadedFile)
                    : node?.media?.url
                }
                alt='image'
                className={styles.image}
              />
            </div>
          </div>
        )}

        <Handle
          type='source'
          position={Position.Right}
          className='custom-handle'
        />
      </NodeContainer>

      <ImageModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        title='Image'
        id={id}
        node={node}
        allowedExtensions={["jpg", "jpeg", "png", "gif", "bmp", "webp"]}
        isError={isError}
        max
      />
    </>
  );
};

export default ImageNode;
